import React from 'react';
import {
  useFormContext,
  RegisterOptions,
} from 'react-hook-form/dist/index.ie11';
import { CookbookServerSelectSearchWrapper } from 'src/components/CookbookServerSelectSearchWrapper/CookbookServerSelectSearchWrapper';
import { addAsterisk } from 'src/components/enterprise/features/Corporate/components/Form/utils/addAsterisk';
import { useDepartmentsSelectSearchControl } from './hooks/useDepartmentsSelectSearchControl';

export interface DepartmentsSelectSearchControlProps {
  name: string;
  id: string;
  rules?: RegisterOptions;
}

export function DepartmentsSelectSearchControl({
  name,
  id,
  rules = {},
}: DepartmentsSelectSearchControlProps): JSX.Element {
  const { control, errors } = useFormContext();
  const { options, handleSearchChange, isLoadingFetchedDepartment } =
    useDepartmentsSelectSearchControl({
      name,
      rules,
    });

  return (
    <CookbookServerSelectSearchWrapper
      name={name}
      id={id}
      blockWidth
      control={control}
      error={errors[name]}
      label={addAsterisk('Department', rules)}
      placeholder={
        isLoadingFetchedDepartment ? 'loading...' : 'Select department'
      }
      options={options}
      fetchOptions={handleSearchChange}
      rules={rules}
    />
  );
}
